import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Dialog, DialogTitle, styled, TextField, Typography } from '@mui/material';
import ReportarRecargaForm from './fondos/reporteRecarga/ReportarRecargaForm';
import useWallet from '../../../hooks/useWallet';
import { fCurrency } from '../../../utils/formatNumber';
import PropTypes from 'prop-types';
import AgregarFondosWallet from './fondos/AgregarFondosWallet';
import { firestore } from '../../../contexts/FirebaseContext';
import { useSnackbar } from 'notistack';
import useAuthUsers from '../../../hooks/useAuthUsers';

const CuztomCard = styled(Card)(() => ({
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px'
}));

const SaldoBox = styled(Box)(() => ({
  display: 'flex',
  gap: '15px'
}));

function Balance({ wallet, assignedUser = false, currentUser }) {
  const [addSaldo, setAddSaldo] = useState(false);
  const { saldoServicio, saldoPaqueteria, saldoRecarga } = wallet;

  const { currentHostUser } = useAuthUsers();

  console.log('esta es---------------------', currentHostUser);

  return (
    <CuztomCard>
      <img width="40%" src="/static/illustrations/wallet_img.svg" alt="as" />
      <Typography fontSize="20px" marginTop="20px">
        Balance de saldos:
      </Typography>
      <SaldoBox>
        <Typography variant="subtitle1">Saldo de servicios: </Typography>
        <Typography fontSize="20px">{fCurrency(saldoServicio)}</Typography>
      </SaldoBox>
      <SaldoBox>
        <Typography variant="subtitle1">Saldo de paqueteria: </Typography>
        <Typography fontSize="20px">{fCurrency(saldoPaqueteria)}</Typography>
      </SaldoBox>
      <SaldoBox>
        <Typography variant="subtitle1">Saldo de recarga: </Typography>
        <Typography fontSize="20px">{fCurrency(saldoRecarga)}</Typography>
      </SaldoBox>
      <Box sx={{ marginTop: '20px' }}>
        <Button variant="outlined" size="small" onClick={() => setAddSaldo(true)}>
          Agregar Fondos
        </Button>
        {assignedUser ? (
          <AgregarFondosWallet open={addSaldo} setAddSaldo={setAddSaldo} usedUser={currentHostUser} />
        ) : (
          <AgregarFondosWallet open={addSaldo} setAddSaldo={setAddSaldo} usedUser={currentUser} />
        )}
      </Box>
    </CuztomCard>
  );
}

export default Balance;
